import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';

interface IGalleryAction {
    variables?: {
        dir: string;
        parent_dir: string;
    };
}

export interface IMediaAction {
    variables?: {
        path: string;
        fileName: string;
        file: string;
    };
}

export interface IRemoveMedia {
    variables?: {
        from: string;
        file: string;
    };
}

export const CREATE_DIR = gql`
    mutation useCreateDir($parent_dir: String!, $dir: String!) {
        makeDir(from: $parent_dir, add: $dir) {
            id
            path
        }
    }
`;

export const DELETE_DIR = gql`
    mutation useDeleteDir($dir: String!, $parent_dir: String!) {
        removeDir(from: $parent_dir, remove: $dir)
    }
`;

export const UPLOAD_MEDIA = gql`
    mutation useUploadMedia($path: String!, $fileName: String!, $file: Upload!) {
        uploadModelMedia(path: $path, fileName: $fileName, file: $file) {
            relativePath
            url
        }
    }
`;

export const DELETE_MEDIA = gql`
    mutation useDeleteMedia($from: String!, $remove: String!) {
        removeFile(from: $from, remove: $remove)
    }
`;

const useCreateDir = ({ variables }: IGalleryAction) => {
    return useMutation(CREATE_DIR, {
        variables,
        awaitRefetchQueries: true,
        fetchPolicy: 'no-cache',
    });
};

const useDeleteDir = ({ variables }: IGalleryAction) => {
    return useMutation(DELETE_DIR, {
        variables,
        awaitRefetchQueries: true,
        fetchPolicy: 'no-cache',
    });
};

const useUploadMedia = ({ variables }: IMediaAction) => {
    return useMutation(UPLOAD_MEDIA, {
        variables,
        awaitRefetchQueries: true,
        fetchPolicy: 'no-cache',
    });
};

const useDeleteMedia = ({ variables }: IRemoveMedia) => {
    return useMutation(DELETE_MEDIA, {
        variables,
        awaitRefetchQueries: true,
        fetchPolicy: 'no-cache',
    });
};

export { useCreateDir, useDeleteDir, useUploadMedia, useDeleteMedia };
